import * as Sentry from '@sentry/browser'
import { toast } from 'react-toastify'

import { getEnvironment } from '../utils/errorHandling'

// Add messages to this list you don't want to report to Sentry
const ERROR_EXCEPTIONS = [
  'TypeError: Failed to fetch',
  'ResizeObserver loop limit exceeded',
  'ResizeObserver loop completed with undelivered notifications.'
]

// Start sentry when not developing
export function initializeSentry() {
  const environment = getEnvironment()
  if (environment !== 'localhost') {
    Sentry.init({
      dsn: 'https://1dac6a7f5e3e475fba164d276eadbd6f@sentry.io/1270885',
      // should be set in package.json
      release: process.env.REACT_APP_GIT_SHA,
      ignoreErrors: ERROR_EXCEPTIONS,
      environment
    })
  }
}

/**
 * Send a error to Sentry with additional info
 * @param {Error | RestError} error
 * @param {Object} [additionalInfo] Any object that will be added to the sentry error details
 */
export function sendExceptionToSentry(error, additionalInfo) {
  if (!error) {
    return
  }

  // Prevent default messages to be send to sentry
  let doNotSend = false
  ERROR_EXCEPTIONS.forEach(exceptionError => {
    if (error.message && error.message.includes(exceptionError)) {
      doNotSend = true
    }
  })
  if (doNotSend) {
    return
  }

  // Send to sentry
  Sentry.withScope(scope => {
    if (additionalInfo) {
      Object.keys(additionalInfo).forEach(key => {
        scope.setExtra(key, additionalInfo[key])
      })
    }
    Sentry.captureException(error)
  })
}

/**
 * Send a custom message to Sentry
 * @param {string} message
 * @param {object} additionalInfo Any object that will be added to the sentry error details
 */
export function sendMessageToSentry(message, additionalInfo) {
  Sentry.withScope(scope => {
    if (additionalInfo) {
      Object.keys(additionalInfo).forEach(key => {
        scope.setExtra(key, additionalInfo[key])
      })
    }
    Sentry.captureMessage(message)
  })
}

/**
 * Any catch error handling
 * @param {CustomError} err
 * @param {string} [customToastMessage]
 */
export function handleFetchError(err, customToastMessage) {
  console.error(err)

  // Prevent unauthorized messages to be reported
  if (err.status === 401) {
    return
  }

  const errMessage = err.message || String(err.error) || String(err)
  sendExceptionToSentry(err.response, { message: errMessage, error: err })

  if (errMessage.includes('Failed to fetch')) {
    toast.error('No network connection found, please try to reconnect', { autoClose: false, toastId: errMessage })
  } else {
    toast.error(customToastMessage || errMessage.toString(), { autoClose: false, toastId: errMessage })
  }
}
